/**
 * StaffGeschaeftOpsHub — IT-SCE Intern: "Geschäft-Ops"-Sektion mit Sub-Tabs.
 *
 * TQ #9696 (Staff-Migration Teil C, Bundle #9523, ZIELBILD-Unified-Cockpit).
 * Bündelt die 4 operativen Geschäfts-Seiten unter einem Hub, gespiegelt nach
 * dem StaffCustomersHub-Muster (Teil A, TQ #9694):
 *   - Service-Katalog       → /staff/service-catalog   (admin-api Catalog)
 *   - Anfragen              → /staff/service-requests  (admin-api Service-Requests)
 *   - Provisioning-Queue    → /staff/provisioning-queue (portal-api needs_attention)
 *   - Tenant onboarden      → /staff/tenant-onboarding (portal-api Tenant-Foundation)
 *
 * Routing: alle 4 Pfade rendern diesen Hub (App.tsx, hinter StaffOnly-Guard,
 * VOR /:slug/*); der aktive Tab wird aus dem Pfad abgeleitet, ein Tab-Klick
 * navigiert (kein Reload). Präzedenz: StaffCustomersHub.
 */

import { useLocation, useNavigate } from 'react-router-dom'
import StaffServiceCatalog from './StaffServiceCatalog'
import StaffServiceRequests from './StaffServiceRequests'
import StaffProvisioningQueue from './StaffProvisioningQueue'
import StaffTenantOnboarding from './StaffTenantOnboarding'

interface Tab {
  id: string
  label: string
  icon: string
  path: string
}

const TABS: Tab[] = [
  { id: 'service-catalog', label: 'Service-Katalog', icon: '📦', path: '/staff/service-catalog' },
  { id: 'service-requests', label: 'Anfragen', icon: '📨', path: '/staff/service-requests' },
  { id: 'provisioning-queue', label: 'Provisioning-Queue', icon: '⚙️', path: '/staff/provisioning-queue' },
  { id: 'tenant-onboarding', label: 'Tenant onboarden', icon: '🏢', path: '/staff/tenant-onboarding' },
]

function activeTab(path: string): string {
  if (path.includes('/service-requests')) return 'service-requests'
  if (path.includes('/provisioning-queue')) return 'provisioning-queue'
  if (path.includes('/tenant-onboarding')) return 'tenant-onboarding'
  return 'service-catalog'
}

export default function StaffGeschaeftOpsHub() {
  const navigate = useNavigate()
  const path = useLocation().pathname
  const active = activeTab(path)

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: '2rem 1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
        <a href="/" style={{ color: '#FF6B35', textDecoration: 'none', fontSize: '0.9rem' }}>
          ← Cockpit
        </a>
      </div>
      <h1 style={{ margin: 0, fontSize: '1.6rem' }}>🧩 Geschäft-Ops</h1>

      <nav style={{ display: 'flex', gap: 4, marginTop: '1rem', marginBottom: '1.5rem', borderBottom: '1px solid #e5e7eb' }} role="tablist">
        {TABS.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={active === t.id}
            onClick={() => navigate(t.path)}
            style={{
              padding: '0.6rem 1rem',
              border: 'none',
              borderBottom: active === t.id ? '2px solid #FF6B35' : '2px solid transparent',
              background: 'none',
              color: active === t.id ? '#FF6B35' : '#374151',
              fontWeight: active === t.id ? 600 : 400,
              cursor: 'pointer',
              fontSize: '0.95rem',
            }}
          >
            <span aria-hidden>{t.icon}</span> {t.label}
          </button>
        ))}
      </nav>

      <div role="tabpanel">
        {active === 'service-catalog' && <StaffServiceCatalog />}
        {active === 'service-requests' && <StaffServiceRequests />}
        {active === 'provisioning-queue' && <StaffProvisioningQueue />}
        {active === 'tenant-onboarding' && <StaffTenantOnboarding />}
      </div>
    </div>
  )
}
